
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MessageTeaser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teaser"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useTextBody"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"teaser"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useTextBody"}}}]},{"kind":"Directive","name":{"kind":"Name","value":"stripHtml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"truncateLength"},"value":{"kind":"Variable","name":{"kind":"Name","value":"truncateBodyLength"}}},{"kind":"Argument","name":{"kind":"Name","value":"removeProcessingText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeProcessingText"}}}]}]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
